export const UNIT_TYPES = [
  { value: 'container_single', label: 'Portacontenedor sencillo' },
  { value: 'container_full', label: 'Portacontenedor full' },
  { value: '3_5_ton', label: '3.5 Ton' },
  { value: 'rabon', label: 'Rabon' },
  { value: 'dry_box_53', label: "Caja seca 53'" },
  { value: 'dry_box_48', label: "Caja de 48'" },
  { value: 'dry_box_40', label: "Caja seca de 40'" },
  { value: 'refrigerated_box', label: 'Caja refrigerada' },
  { value: 'sprinter_van', label: 'Sprinter van' },
  { value: 'lowboy', label: 'Lowboy' },
  { value: 'flatbed_48', label: "Flatbed 48'" },
  { value: 'flatbed_53', label: 'Flatbed 53' },
  { value: 'flatbed_40', label: "Flatbed 40'" },
  { value: 'torton', label: 'Torton' },
  { value: '1_ton', label: '1 Ton' },
];

export default UNIT_TYPES;
